import { Flex, Pagination } from '@node-real/uikit';
import styled from '@emotion/styled';
import { useResponsive } from '@op-bridge/bridge-core';

export const TableWrapper = ({
  page,
  pageSize,
  text,
  total,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  text: string;
  total: number;
  onPageChange: (page: number) => void;
}) => {
  const { isMobile } = useResponsive();
  return (
    <Container justifyContent={'space-between'} alignItems={'center'}>
      <WrapperText>{text && text}</WrapperText>
      {total > pageSize && (
        <StyledPagination
          current={page}
          pageSize={pageSize}
          onChange={onPageChange}
          // TODO Change back to 999
          total={total}
          sx={{
            button: {
              '&.ui-pagination-page': {
                color: 'readable.pageButton',
                background: 'bg.status',
                '&:hover': {
                  background: 'readable.disabled',
                },
              },
              '&.ui-pagination-next-button': {
                '&:not([disabled])': {
                  color: 'readable.pageButton',
                  background: 'bg.status',
                  width: 24,
                  height: 24,
                  borderRadius: 4,
                  '&:hover': {
                    background: 'readable.disabled',
                  },
                },
              },
              '&.ui-pagination-prev-button': {
                '&:not([disabled])': {
                  color: 'readable.pageButton',
                  background: 'bg.status',
                  width: 24,
                  height: 24,
                  borderRadius: 4,
                  '&:hover': {
                    background: 'readable.disabled',
                  },
                },
              },
              '&[disabled]': {
                background: 'bg.status',
                color: 'readable.disabled',
                _hover: {
                  background: 'bg.status',
                  color: 'readable.disabled',
                },
              },
            },
            '.ui-pagination-quick-jumper': {
              display: isMobile ? 'none' : 'flex',
              color: '#76808F',
              '.ui-input': {
                color: 'readable.white',
                backgroundColor: 'bg.status',
                _hover: {
                  borderColor: 'scene.primary.normal',
                },
              },
            },
          }}
        ></StyledPagination>
      )}
    </Container>
  );
};

const Container = styled(Flex)`
  padding: 20px 0;
`;

const WrapperText = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  color: ${(props: any) => props.theme.colors.readable.grey10};
`;

const StyledPagination = styled(Pagination)`
  button[data-selected] {
    color: ${(props: any) => props.theme.colors.readable.link};
  }
`;
